'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _fees_card_data_point = require('./fees_card_data_point.js');

var _fees_card_data_point2 = _interopRequireDefault(_fees_card_data_point);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _collection_utility = require('common-utilities/src/collection_utility');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeesCard = function (_React$Component) {
  _inherits(FeesCard, _React$Component);

  function FeesCard() {
    _classCallCheck(this, FeesCard);

    return _possibleConstructorReturn(this, (FeesCard.__proto__ || Object.getPrototypeOf(FeesCard)).apply(this, arguments));
  }

  _createClass(FeesCard, [{
    key: 'validateCommingledFees',
    value: function validateCommingledFees(value) {
      if (this.props.fundTypeCode === 'Commingled' && (0, _ramda.isNil)(value)) {
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: 'getHighestDecimalPointCount',
    value: function getHighestDecimalPointCount(displayItems, visibleDataPoints) {
      var _this2 = this;

      var highestNumberOfDecimalPoints = 2;
      (0, _ramda.map)(function (displayItem) {
        if (_collection_utility.CollectionUtility.includes(visibleDataPoints, displayItem.visibleDataPoint) && _this2.validateCommingledFees(displayItem.value) && _number_utility2.default.getDecimalPointCount(displayItem.value) > highestNumberOfDecimalPoints) {
          highestNumberOfDecimalPoints = _number_utility2.default.getDecimalPointCount(displayItem.value);
        }
      }, displayItems);
      return highestNumberOfDecimalPoints;
    }
  }, {
    key: 'renderDisplayItem',
    value: function renderDisplayItem(displayItems, visibleDataPoints, formattingRules) {
      var _this3 = this;

      var NON_NUMERIC_DATA_POINTS = ["SHARECLASS_FEES_EXPENSECAP_EXPIRYDATE", "SHARECLASS_FEES_ANNUAL_MANAGEMENT_FEE_TEXT"];

      var feesCardItems = [];
      var highestNumberOfDecimalPoints = this.getHighestDecimalPointCount(displayItems, visibleDataPoints);
      if (_collection_utility.CollectionUtility.includes(formattingRules, "FEES_DATA_SHOW_IN_TWO_DECIMAL")) {
        highestNumberOfDecimalPoints = 2;
      }
      (0, _ramda.map)(function (displayItem) {
        if (_collection_utility.CollectionUtility.includes(visibleDataPoints, displayItem.visibleDataPoint) && _this3.validateCommingledFees(displayItem.value)) {
          if ("SHARECLASS_FEES_FEEWAIVER" === displayItem.visibleDataPoint) {
            var feesWaiver = _number_utility2.default.formatToPercentWithSuppliedDecimalPointCount(displayItem.value, highestNumberOfDecimalPoints);
            if (Number(displayItem.value) !== 0) {
              feesWaiver = "-" + feesWaiver;
            }
            feesCardItems.push(displayItem.element({}, feesWaiver));
          } else if (displayItem.isNestedItem) {
            if (_collection_utility.CollectionUtility.includes(NON_NUMERIC_DATA_POINTS, displayItem.visibleDataPoint)) {
              feesCardItems.push(displayItem.element({ indent: true }, displayItem.value));
            } else {
              feesCardItems.push(displayItem.element({ indent: true }, _number_utility2.default.formatToPercentWithSuppliedDecimalPointCount(displayItem.value, highestNumberOfDecimalPoints)));
            }
          } else if (!_collection_utility.CollectionUtility.includes(NON_NUMERIC_DATA_POINTS, displayItem.visibleDataPoint)) {
            feesCardItems.push(displayItem.element({}, _number_utility2.default.formatToPercentWithSuppliedDecimalPointCount(displayItem.value, highestNumberOfDecimalPoints)));
          } else {
            feesCardItems.push(displayItem.element({}));
          }
        }
      }, displayItems);
      return feesCardItems;
    }
  }, {
    key: 'renderFeeCardDataPoint',
    value: function renderFeeCardDataPoint(datapoint, value, label, dataTest, isNestedItem) {
      var _this4 = this;

      var shouldFormatAsNumber = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

      return {
        visibleDataPoint: datapoint,
        isNestedItem: isNestedItem,
        value: value,
        element: function element(otherProps, value) {
          return _react2.default.createElement(_fees_card_data_point2.default, _extends({
            key: dataTest }, otherProps, { label: label, dataTest: dataTest, value: value, numberFormat: shouldFormatAsNumber ? _this4.props.numberFormat : null }));
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var displayItems = [];

      if (this.props.fees) {
        displayItems.push({
          visibleDataPoint: "SHARECLASS_FEES_EXPENSECAP_EXPIRYDATE",
          value: this.props.fees.expenseCapExpiryDate,
          element: function element(otherProps) {
            return _react2.default.createElement(_fees_card_data_point2.default, _extends({
              key: 'expiry-date',
              label: 'Expense Cap Expiration Date',
              dataTest: 'expiry-date',
              value: _date_formatter2.default.getDateInSlashFormat(_this5.props.fees.expenseCapExpiryDate),
              numberFormat: _this5.props.numberFormat
            }, otherProps));
          }
        });

        var showComprises = (0, _ramda.isNil)(this.props.fees.opAdminExpenses) && (0, _ramda.isNil)(this.props.fees.annualMgmtAdvFees) && (0, _ramda.isNil)(this.props.fees.distributionFee) || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "SHARECLASS_FEES_OPERATING_AND_ADMINISTRATIVE_EXPENSES") && _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "SHARECLASS_FEES_ANNUAL_MANAGEMENT_FEE");

        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_INVESTMENT_MANAGEMENT", this.props.fees.investmentManagement, _string_utility2.default.renderFormattedLabel('Investment Management Fees', 'pdp-performance-fees-investment-management', { fundType: this.props.fundTypeCode != null ? this.props.fundTypeCode.replaceAll(" ", "_") : this.props.fundTypeCode }), 'investment-mgmt'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_EXPENSES_MER", this.props.fees.mer, _string_utility2.default.renderFormattedLabel('MER', 'pdp-performance-fees-mer'), 'mer'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_STOCKHOLDER_SERVING", this.props.fees.stockholderServiceFee, 'Stockholder Servicing Fees', 'stockholder-service'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_INCENTIVE_FEE", this.props.fees.incentiveFee, _string_utility2.default.renderFormattedLabel('Incentive Fee', "pdp-performance-fees-incentive-fee"), 'incentive-fee'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_SERVICE", this.props.fees.serviceFees, 'Service Fees', 'service-fees'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_OTHER_EXPENSE", this.props.fees.otherExpense, 'Other Expenses', 'other-expenses'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_ACQUIRED_FUND", this.props.fees.acquiredFund, 'Acquired Fund Fees', 'acquired-fees'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_ANNUALOPERATINGEXPENSES", this.props.fees.annualOperatingExpenses, 'Total Annual Operating Expenses', 'annual-operating-expense'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_FEEWAIVER", this.props.fees.feeWaiver, 'Fee Waivers and/or Expense Reimbursements', 'fee-waiver'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_EXPENSES_GROSSEXPENSE", this.props.expenses.grossExpense, _string_utility2.default.renderFormattedLabel('Gross Expenses', "pdp-performance-fees-gross-expense"), 'gross-expenses'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_EXPENSES_NETEXPENSE", this.props.expenses.netExpense, _string_utility2.default.renderFormattedLabel('Net Expenses', "pdp-performance-fees-net-expense"), 'net-expenses'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_EXPENSELESS", this.props.fees.expenseLess, 'Net Expenses Excluding Dividend and Interest Expenses On Short Sales from Underlying Funds', 'expense-less'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_EXPENSERATIO", this.props.fees.expenseRatio, 'Expense Ratio', 'expense-ratio'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_SUBSCRIPTION_FEES", this.props.fees.subscriptionFees, _string_utility2.default.renderFormattedLabel('Initial charge', 'pdp-performance-fees-initial-charge'), 'susbscription-fees'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_REDEMPTION_FEES", this.props.fees.redemptionFees, _string_utility2.default.renderFormattedLabel('Redemption charge', 'pdp-performance-fees-redemption-charge'), 'redemption-fees'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_PUBLISHED_ONGOING_CHARGE", this.props.fees.publishedOngoingCharge, _string_utility2.default.renderFormattedLabel('Ongoing charge', 'pdp-performance-fees-ongoing-charge', { fundType: !showComprises ? '' : this.props.fundTypeCode }), 'published-ongoing-charge'));
        displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_ONGOING_CHARGE", this.props.fees.ongoingCharge, _string_utility2.default.renderFormattedLabel('Ongoing charge', 'pdp-performance-fees-ongoing-charge', { fundType: !(0, _ramda.isNil)(this.props.fees.opAdminExpenses) ? this.props.fundTypeCode : '' }), 'ongoing-charge'));
        displayItems.push(!(0, _ramda.isNil)(this.props.fees.annualMgmtAdvFeesText) ? this.renderFeeCardDataPoint("SHARECLASS_FEES_ANNUAL_MANAGEMENT_FEE_TEXT", this.props.fees.annualMgmtAdvFeesText, 'Annual management fee', 'annual-management-fee', true, false) : this.renderFeeCardDataPoint("SHARECLASS_FEES_ANNUAL_MANAGEMENT_FEE", this.props.fees.annualMgmtAdvFees, _string_utility2.default.renderFormattedLabel('Annual management fee', 'pdp-performance-fees-annual-management-fee'), 'annual-management-fee', true));
        (0, _ramda.isNil)(this.props.fees.establishmentCosts) ? '' : displayItems.push(this.renderFeeCardDataPoint("ESTABLISHMENT_COST_FEE", this.props.fees.establishmentCosts, _string_utility2.default.renderFormattedLabel('Establishment costs', 'pdp-performance-fees-establishment-cost'), 'establishment-cost', true));
        (0, _ramda.isNil)(this.props.fees.opAdminExpenses) ? '' : displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_OPERATING_AND_ADMINISTRATIVE_EXPENSES", this.props.fees.opAdminExpenses, _string_utility2.default.renderFormattedLabel('Operating & administrative expenses', 'pdp-performance-fees-operating-admin-charge'), 'operating-administrative-expenses', true));
        (0, _ramda.isNil)(this.props.fees.distributionFee) || this.props.fees.distributionFee === 0 ? '' : displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_DISTRIBUTION_FEE", this.props.fees.distributionFee, _string_utility2.default.renderFormattedLabel('Distribution Fee', 'pdp-performance-fees-distribution-fee'), 'distribution-fee', true));
        (0, _ramda.isNil)(this.props.fees.perfFeeRate) || this.props.fees.perfFeeRate === 0 ? '' : displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_PERF_FEE_RATE", this.props.fees.perfFeeRate, _string_utility2.default.renderFormattedLabel('Performance fee', 'pdp-performance-fees-performance-fee'), 'perf-fee-rate'));
        !(0, _ramda.isNil)(this.props.fees.transactionCosts) ? displayItems.push(this.renderFeeCardDataPoint("SHARECLASS_FEES_TRANSACTION_COSTS", this.props.fees.transactionCosts, _string_utility2.default.renderFormattedLabel('Transaction Costs', 'pdp-performance-fees-transaction-costs'), 'transaction-costs')) : '';
      }

      var secondDisclosure = null;
      var secondPlacementId = null;
      var thirdDisclosure = null;
      var thirdPlacementId = null;
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'BELGIUM_PERFORMANCE_FEES_DISCLOSURE')) {
        secondDisclosure = this.props.disclosures.pdpCardFeesBelgiumPerformance;
        secondPlacementId = "pdpCardFeesBelgiumPerformance";
      }
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'BELGIUM_TRANSACTION_COSTS_DISCLOSURE')) {
        thirdDisclosure = this.props.disclosures.pdpCardFeesBelgiumTransaction;
        thirdPlacementId = "pdpCardFeesBelgiumTransaction";
      }
      var additionalDisclosures = [];
      var showOngoingCharge = _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHARECLASS_FEES_ONGOING_CHARGE') || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHARECLASS_FEES_PUBLISHED_ONGOING_CHARGE');
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'EU_ONGOING_CHARGE_DISCLOSURE') && showOngoingCharge) {
        additionalDisclosures.push({
          text: (0, _functional_utility.pathOrNull)(['disclosures', 'pdpCardFeesOngoingChargeEU'], this.props),
          placementId: 'pdpCardFeesOngoingChargeEU'
        });
      }
      return _react2.default.createElement(
        _card_component2.default,
        {
          headerTitle: _string_utility2.default.renderFormattedLabel('Fees', 'pdp-performance-fees-header-label'),
          headerTitleId: "feesCard",
          headerTitleLabel: "",
          headerLabel: "",
          disclosureText: this.props.disclosure,
          breakpoint: this.props.breakpoint,
          placementId: "pdpCardFees",
          secondDisclosureText: secondDisclosure || this.props.secondDisclosure,
          secondPlacementId: secondPlacementId || "pdpCardAcquiredFundFees",
          thirdDisclosureText: thirdDisclosure,
          thirdPlacementId: thirdPlacementId,
          additionalDisclosures: additionalDisclosures,
          dataTest: 'fees-card',
          alwaysShowFullDisclosure: _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'ALWAYS_SHOW_MORE_DISCLOSURES')
        },
        _react2.default.createElement(
          'div',
          { className: 'container width-percent-100 padding-all-0' },
          this.renderDisplayItem(displayItems, this.props.visibleDataPoints, this.props.formattingRules)
        )
      );
    }
  }]);

  return FeesCard;
}(_react2.default.Component);

exports.default = FeesCard;